import { jumpComRouter } from "@/utils/host";
import TransitionImage from "./TransitionImage.vue";
export default {
  components: {
    TransitionImage
  },
  props: {
    isMobile: Boolean,
    swipeItem: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      showRef: true,
      frameStyle: {
        height: "100%"
      }
    };
  },
  computed: {
    picObj() {
      return {
        src: this.swipeItem.pic,
        alt: this.swipeItem.alt || this.swipeItem.page
      };
    }
  },
  beforeMount() {
    if (window._templateHeight) {
      this.showRef = false;
      this.frameStyle.height = window._templateHeight;
    }
  },
  mounted() {
    if (this.showRef) {
      let bound = this.$refs.swipePicRef && this.$refs.swipePicRef.getBoundingClientRect();
      if (bound) {
        this.frameStyle.height = bound.height + "px";
        window._templateHeight = this.frameStyle.height;
      }
    }
  },
  methods: {
    applyTemplate() {
      jumpComRouter("template@pages");
    }
  }
};